import { ActionIcon } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

export default function CopyTextActionIcon({ text, ...props }) {
  return (
    <ActionIcon
      size="sm"
      color="gray.6"
      variant="outline"
      {...props}
      onClick={() => {
        navigator.clipboard.writeText(text).then(
          function () {
            notifications.show({
              color: "green",
              autoClose: 2000,
              title: "Text copied to clipboard",
            });
          },
          function (err) {
            notifications.show({
              color: "red",
              autoClose: 4000,
              title: "Failed to copy text to clipboard",
              message: "Details: " + err.message,
            });
          }
        );
      }}
    >
      <IconCopy size={14} />
    </ActionIcon>
  );
}
